import { render } from "./ThirdBar.vue?vue&type=template&id=a5ce1880&scoped=true"
import script from "./ThirdBar.vue?vue&type=script&lang=js"
export * from "./ThirdBar.vue?vue&type=script&lang=js"

import "./ThirdBar.vue?vue&type=style&index=0&id=a5ce1880&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ce1880"]])

export default __exports__